export class CodeType {

    constructor() { }

    public CodeID: number;
    public Description: string;
    public Category: string;
    public IsSystem: number;
    public IsCommon: number;
    public IsSysUser: number;
    public ProductID?: number;
    public State: string;
    public VersionNo?: number;
    public MaxLength?: number;
    public Notes: string;
    public DropDown: string;
    public CreatedDttmUTC?: Date;
    public ModifiedDttmUTC?: Date;
}


// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/core/codetype.model.ts